module.exports = __webpack_public_path__ + "img/14-4.e81c1b65.png";